import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {MediaMatcher} from '@angular/cdk/layout';
import {Location} from '@angular/common';
import {ContactDialogComponent} from '../shared/components/dialogs';
import {MatDialog} from '@angular/material';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';

import {filter} from 'rxjs/operators';
import {environment} from '../../environments/environment';


@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {
  readonly SITE_URL = `${environment.SITE_URL}/`;
  navLinks: any[];
  mobileQuery: MediaQueryList;
  readonly mobileQueryListener: () => void;
  currentUrl: string;
  checked = false;
  mobileMode = false;
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog
    ) {
    this.navLinks = [
      {
        label: 'התחברות',
        link: './login',
        index: 0
      }, {
        label: 'משתמש חדש',
        link: './sign-up',
        index: 1
      }
    ];
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileMode = this.mobileQuery.matches;
    // this.mobileQuery.addEventListener('change', this.mobileQueryListener);
  }

  ngOnInit() {

    this.currentUrl = this.route.firstChild.routeConfig.path;
    this.router.events.pipe(filter(evt => evt instanceof NavigationEnd))
      .subscribe((event) => {
        this.currentUrl = this.route.firstChild.routeConfig.path;
      });

    if (window.innerWidth < 980 && !this.currentUrl) {
      this.router.navigateByUrl('/auth');
    }
  }

  backClicked() {
    this.location.back();
  }

  openDialog() {
    const dialogRef = this.dialog.open(ContactDialogComponent, {
      panelClass: 'contact-dialog',
      data: {
        context: 'login page',
      }
    });
  }

  selectRoute(mode: boolean, route: string) {
    this.mobileMode = mode;
    if (route) {
      this.router.navigateByUrl('/auth/' + route);
    }
  }

  sendCallEvent() {
    window.dataLayer.push({
      event: 'employer-call',
      eventCategory: 'auth-page',
      eventAction: 'success',
    });
  }

}
